module.exports = __webpack_public_path__ + "img/left-arrow.c399cef7.svg";